import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

interface Member {
  user_id: number;
  full_name: string;
  callsign: number;
  rank: string;
  entry_date: string | Date;
  last_up: string | Date;
  discordID: string;
  functions?: Record<string, boolean | string>;
  certificates?: Record<string, boolean | string>;
  fw: number;
  notes: string;
  grade: string;
  cooldowns: boolean;
  reintegrated: boolean;
  email: string;
}

interface Punishment {
  callsign: string;
  reason: string;
  amount: number;
  hr: string;
  punishments: any;
  date: string;
  expire: string;
  status: boolean;
  pType: string; 
  fw: number;
}

interface Token {
  email: string,
  token: string
}

export const useData = () => {
  const [membersData, setData] = useState<Member[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await axios.get<Member[]>('http://panelmedici.fplayt.ro:5000/api/data');
      const processedData = response.data.map((element) => {
        const updatedElement = { ...element };

        if (element.functions && typeof element.functions === 'string') {
          try {
            updatedElement.functions = JSON.parse(element.functions);
          } catch (e) {
            console.error('Error parsing functions:', e);
          }
        }

        if (element.certificates && typeof element.certificates === 'string') {
          try {
            updatedElement.certificates = JSON.parse(element.certificates);
          } catch (e) {
            console.error('Error parsing certificates:', e);
          }
        }

        return updatedElement;
      });

      setData(processedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getMemberInfo = (callsign: number, type: keyof Member): any => {
    const member = membersData.find((m) => m.callsign === callsign);
    return member ? member[type] : null;
  };

  const getDiscordMemberInfo = (dID: string, type: keyof Member): any => {
    const member = membersData.find((m) => m.discordID === dID);
    return member ? member[type] : null;
  };

  async function refreshAccessToken() {
    const refreshToken = Cookies.get("refreshToken");
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (60 * 60 * 1000));

    if (!refreshToken) {
      return console.error("No refresh token available");
    }

    try {
      const response = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
        refreshToken: refreshToken,
      });

      Cookies.set("accessToken", response.data.accessToken, { expires: expiryDate });

      if (response.data.refreshToken) {
        Cookies.set("refreshToken", response.data.refreshToken, { expires: 7 });
      }

      return response.data.accessToken;
    } catch (error) {
      console.error("Error refreshing access token: ", error);
    }
  }

  return { membersData, loading, getMemberInfo, getDiscordMemberInfo, fetchData, refreshAccessToken };
};


export const useTokenEmail = () => {
  const [tokenData, setData] = useState<Token[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await axios.get<Token[]>('http://panelmedici.fplayt.ro:5000/api/tokenData');
      setData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { tokenData, loading };
};

export const usePunishments = () => {
  const [membersPunishments, setPData] = useState<Punishment[]>([]);
  const [pLoading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await axios.get<Punishment[]>('http://panelmedici.fplayt.ro:5000/api/punishmentsData');
      setPData(response.data.reverse());
    } catch (error) {
      console.error('Error fetching punishments:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); 

  return { membersPunishments, pLoading };
};
